import { useActionSheet } from '@expo/react-native-action-sheet';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { i18nNS } from '../i18n';

export const useCameraOptions = () => {
  const { t } = useTranslation(i18nNS.tripExpense);
  const [enabledCamera, setEnabledCamera] = useState(false);
  const { showActionSheetWithOptions } = useActionSheet();
  const showOptions = (onRemovePicture) => {
    showActionSheetWithOptions(
      {
        options: [
          t('ExpenseWidget.RetakePicture'),
          t('ExpenseWidget.RemovePicture'),
          t('ExpenseWidget.Cancel'),
        ],
        cancelButtonIndex: 2,
      },
      (buttonIndex) => {
        if (buttonIndex === 0) {
          setEnabledCamera(true);
        } else if (buttonIndex === 1) {
          onRemovePicture();
        }
      }
    );
  };

  const disableCamera = () => setEnabledCamera(false);

  const enableCamera = () => setEnabledCamera(true);

  return [enabledCamera, showOptions, disableCamera, enableCamera];
};
